( function( $ ){

  const $body = $( 'body' );
  const $header = $( '#site-header' );
  const $menu = $( '#menu-wrap' );
  const $toggle = $( '#mobile-menu-toggle' );
  // const $submenu_toggles = $( 'button.sub-menu-toggle', $menu );
  const speed = 300;

  const menu_bp = $header.data( 'menu-bp' );
  const menu_bp_query = window.matchMedia( `( min-width: ${ menu_bp }px )` );


  function is_mobile () {
    return !menu_bp_query.matches;
  }


  // create focus trap
  const focus_trap = focusTrap.createFocusTrap( $header.get(0), {
    onActivate () {
      $toggle.addClass( 'is-active' );
      $menu.addClass( 'visible' );
      $body.addClass( 'menu-open' );
    },
    onDeactivate () {
      $toggle.removeClass( 'is-active' );
      $body.removeClass( 'menu-open' );
      setTimeout( function () {
        $menu.removeClass( 'visible' );
      }, speed );
    },
    initialFocus: $toggle.get(0),
  });


  function resize () {
    const mobile = is_mobile();
    $header.toggleClass( 'mobile', mobile );
    document.querySelector( ':root' ).style.setProperty( '--header-height', `${ $header.outerHeight() }px` );
    $menu.removeClass( 'mobile-transition-enabled' );
    setTimeout( function () {
        $menu.addClass( 'mobile-transition-enabled' );
    }, 0 );
    if ( !mobile ) {
        focus_trap.deactivate();
        $( 'button.sub-menu-toggle' ).closest( 'li' ).each( function () {
          set_submenu_open( $(this), false );
        });
    }
  }


  // init header pad height and set header to fixed
  resize();
  $header.addClass( 'fixed' );
  // trigger height recalculation on breakpoint change
  menu_bp_query.addEventListener( 'change', resize );
  $( window ).on( 'breakpoint_changed', resize );

  // toggle mobile menu on hamburger click
  $toggle.click( () => {
      $body.hasClass( 'menu-open' ) ? focus_trap.deactivate() : focus_trap.activate();
  });


  function set_submenu_open ( $li, opening ) {
    let $btn = $( '> .link-wrap button.sub-menu-toggle', $li );
    if ( !$btn.length ) { return; }
    let $submenu = $( `#${ $btn.attr( 'aria-controls' ) }` );
    if ( !$submenu.length ) { return; }
    $btn.attr( 'aria-expanded', opening ? 'true' : 'false' );
		$submenu.attr( 'aria-hidden', opening ? 'false' : 'true' )[ opening ? 'slideDown' : 'slideUp' ]( speed );
  }


  $menu.on( 'click', 'button.sub-menu-toggle', function () {
    set_submenu_open( $(this).closest( 'li' ), $(this).attr( 'aria-expanded' ) == 'false' );
  });


  $menu.on( 'focusout', 'li.menu-item-has-children', function ( e ) {
    if ( is_mobile() || $.contains( this, e.relatedTarget ) ) { return; }
    set_submenu_open( $(this), false );
  });

  $menu.on( 'click', 'a[href="#"]', function ( e ) {
    e.preventDefault();
    let $btn = $( '+ .sub-menu-toggle', this );
    if ( $btn.length ) {
      $btn.click();
    }
  });

  
})( jQuery );
